import { useTranslation } from 'react-i18next'

import Dialog from '~/components/Dialog'
import LabelValue from '~/components/LabelValue'

function DialogActive({ open, onCancel, onSubmit, tempItem }) {
  const { t } = useTranslation(['buseye'])
  return (
    <Dialog
      open={open}
      title={t('roleManagement.activeTitle')}
      onCancel={onCancel}
      cancelLabel={t('common.no')}
      onSubmit={onSubmit}
      submitLabel={t('common.yes')}
      submitProps={{
        color: 'error',
      }}
      noBorderBottom
    >
      {t('roleManagement.activeConfirm')}
      <LabelValue
        label={t('roleManagement.code')}
        value={tempItem?.code}
        sx={{ mt: 4 / 3 }}
      />
      <LabelValue
        label={t('roleManagement.name')}
        value={tempItem?.name}
        sx={{ mt: 4 / 3 }}
      />
    </Dialog>
  )
}
export default DialogActive
